import React from "react";
import page from "page";

class GamesFilterHead extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			icon: "fa-chevron-right"
		};
		this.sortGames = this.sortGames.bind(this);
		this.handleEnter = this.handleEnter.bind(this);
		this.handleLeave = this.handleLeave.bind(this);
	}

	sortGames(e) {
		paginationData.sortBy = $(e.target).attr("data-sort-type");
		console.log(paginationData.sortBy);
		setTimeout(() => {
			if (paginationData.page != 1) {
				if (paginationData.first && paginationData.second) {
					page(
						"/" +
							paginationData.first +
							"/" +
							paginationData.second +
							"/" +
							paginationData.page +
							"#" +
							paginationData.sortBy
					);
				} else if (paginationData.first) {
					page(
						"/" +
							paginationData.first +
							"/" +
							paginationData.page +
							"#" +
							paginationData.sortBy
					);
				} else {
					page("/" + paginationData.page + "#" + paginationData.sortBy);
				}
			} else {
				if (paginationData.first && paginationData.second) {
					page(
						"/" +
							paginationData.first +
							"/" +
							paginationData.second +
							"/#" +
							paginationData.sortBy
					);
				} else if (paginationData.first) {
					page("/" + paginationData.first + "/#" + paginationData.sortBy);
				} else {
					page("/#" + paginationData.sortBy);
				}
			}
		}, 100);
	}
	handleEnter() {
		this.setState({
			icon: "fa-chevron-down"
		});
	}
	handleLeave() {
		this.setState({
			icon: "fa-chevron-right"
		});
	}
	render() {
		return (
			<ul onMouseEnter={this.handleEnter} onMouseLeave={this.handleLeave}>
				<li className="Submenu">
					<div>
						<i className={`fa ${this.state.icon}`} />
						{translate.ordenar}
					</div>
					<ul>
						<li onClick={this.sortGames} data-sort-type="new">
							{translate.GamesFilterHead_newer}
						</li>
						{this.props.noTopRated !== undefined && this.props.noTopRated ? (
							""
						) : (
							<li onClick={this.sortGames} data-sort-type="topRated">
								{translate.GamesFilterHead_top_rated}
							</li>
						)}
					</ul>
				</li>
			</ul>
		);
	}
}
export default GamesFilterHead;
